<script setup lang="ts">
import { ArrowUpRight } from "lucide-vue-next";
import "@/assets/styles/reference.css";
import heroImage from "@/assets/images/hero-garden-v2.png";
import detailImage from "@/assets/images/team-freiraum-v2.png";
import beforeAfterImage from "@/assets/images/before-after-v2.png";

const projects = [
  { type: "Vorher / Nachher", title: "Vom Resthof zum Freiraum", place: "Wiesbaden · 540 m²", image: beforeAfterImage },
  { type: "Privat", title: "Garten mit Haltung", place: "Taunus · 620 m²", image: heroImage },
  { type: "Team", title: "Menschen, die anpacken", place: "Freiraum GaLaBau · Rhein-Main", image: detailImage }
];
</script>

<template>
  <section class="references-section" id="references">
    <div class="section-shell">
      <div class="section-heading reveal">
        <div><span class="eyebrow">Ausgewählte Arbeiten</span><h2>Räume mit <em>Wirkung.</em></h2></div>
        <p>Drei Beispiele dafür, wie aus Anforderungen eigenständige Orte werden – präzise geplant und handwerklich stark umgesetzt.</p>
      </div>
      <div class="project-grid">
        <article class="project-card reveal" v-for="project in projects" :key="project.title">
          <img :src="project.image" :alt="project.title" />
          <div class="project-overlay" />
          <div class="project-copy"><span>{{ project.type }}</span><h3>{{ project.title }}</h3><p>{{ project.place }}</p></div>
          <div class="project-arrow"><ArrowUpRight /></div>
        </article>
      </div>
    </div>
  </section>
</template>
